import { Card, CardContent } from "@/components/ui/card";
import { formatDateTime } from "@/lib/format";
import { cn } from "@/lib/utils";
import type { MassUpdateJob, MassUpdateJobStatus } from "@/mocks/mass-update-jobs";

const STATUS_CHIP_CLASSNAME: Record<MassUpdateJobStatus, string> = {
  Queued: "bg-muted text-muted-foreground",
  Processing: "bg-[var(--info-bg)] text-[var(--info)]",
  Completed: "bg-[var(--success-bg)] text-[var(--success)]",
  Failed: "bg-[var(--danger-bg)] text-[var(--danger)]",
};

function JobStatusChip({ status }: { status: MassUpdateJobStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        STATUS_CHIP_CLASSNAME[status],
      )}
    >
      {status}
    </span>
  );
}

interface JobsTableProps {
  jobs: MassUpdateJob[];
}

export function JobsTable({ jobs }: JobsTableProps) {
  return (
    <Card>
      <CardContent>
        <div className="overflow-auto rounded-lg border">
          <table className="w-full border-collapse text-sm">
            <thead className="bg-muted text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="px-3 py-2 text-left">Type</th>
                <th className="px-3 py-2 text-left">Status</th>
                <th className="px-3 py-2 text-left">Created</th>
                <th className="px-3 py-2 text-right">Records</th>
                <th className="px-3 py-2 text-left">Error</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((job) => (
                <tr key={job.id} className="border-t">
                  <td className="px-3 py-2 whitespace-nowrap">{job.jobType}</td>
                  <td className="px-3 py-2">
                    <JobStatusChip status={job.status} />
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap">{formatDateTime(job.createdAt)}</td>
                  <td className="px-3 py-2 text-right whitespace-nowrap">{job.recordCount}</td>
                  <td className="px-3 py-2 text-[var(--danger)]">{job.errorMessage ?? ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
